import { dryFetch } from '../../utils/dryFetch';
import { getOwnerID, getOwnerJWT } from '../../utils/DryCookies';
// import track from '../utils/trackers';
import { hydrateUserPanelConfigsClientDatabase, writeSystemValue } from '../offline';
import logger from '../../logger';

export const fetchUserPanelConfigsFromCloud = async () => {
  // track.startTime('fetchUserPanelConfigsFromCloud');
  const ownerID = getOwnerID();
  const ownerJWT = getOwnerJWT();
  const myHeaders = new Headers();
  
  myHeaders.append('Authorization', `Bearer ${ownerJWT}`);

  try {
    const jsonResults = await dryFetch({
      name: 'fetchUserPanelConfigs',
      path: `/panel-configs/${ownerID}`,
    });

    const {
      result: userPanelConfigs
    } = jsonResults;
    // const completedTime = track.endTime('fetchUserPanelConfigsFromCloud');
    // logger.info({
    //   ownerID,
    //   time: completedTime,
    // }, 'fetchUserPanelConfigs time');
    // track.time({
    //   category: 'user_panels',
    //   name: 'fetch_user_panel_configs',
    //   value: completedTime,
    //   label: '',
    // });

    writeSystemValue({
      name: 'userPanelConfigsLastSynced',
      utcDateTime: userPanelConfigs.utcDateTime,
    });

    await hydrateUserPanelConfigsClientDatabase({ userPanelConfigs });
    return userPanelConfigs;
  } catch (error) {
    logger.error(error);
    return error;
  }
};
